import axios from 'axios';
import { API_URL } from '../config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: `${API_URL}`,
  headers: { 'Content-Type': 'application/json' }
});

// Add request interceptor to include JWT token in all requests
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

export const userService = {
  create: async ({ username, email, password }) => {
    const response = await api.post('/auth/register', { username, email, password });
    return response.data;
  },
  list: async () => {
    // Based on the backend route definition
    const response = await api.get('/users');
    return response.data;
  },
  update: async (user_id, { username, email }) => {
    const response = await api.put(`/users/${user_id}`, { username, email });
    return response.data;
  },
  delete: async (user_id) => {
    const response = await api.delete(`/users/${user_id}`);
    return response.data;
  },
  resetPassword: async (user_id, newPassword) => {
    const response = await api.post(`/users/${user_id}/reset-password`, { newPassword });
    return response.data;
  },
  listCreatedByMe: async () => {
    const response = await api.get('/users/created-by-me');
    return response.data;
  },
  inviteUser: async ({ email, role, teamId }) => {
    const response = await api.post('/users/invite', { email, role, teamId });
    return response.data;
  },
  updateUserAIModel: async (user_id, { ai_provider, ai_model }) => {
    // Use the preferences API endpoint instead of a user-specific endpoint
    const response = await api.put(`/preferences/ai/user/${user_id}`, { ai_provider, ai_model });
    return response.data;
  },
  getUserAIModels: async (user_id) => {
    try {
      const response = await api.get(`/preferences/ai/user/${user_id}/models`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user AI models:', error);
      // Return a structured error response
      return {
        success: false,
        message: error.message || 'Failed to fetch AI models',
        models: []
      };
    }
  },
  assignAIModel: async (user_id, { ai_provider, ai_model, is_default }) => {
    const response = await api.post(`/preferences/ai/user/${user_id}/models`, { 
      ai_provider, 
      ai_model,
      is_default: is_default || false
    });
    return response.data;
  },
  removeAIModel: async (user_id, provider, model) => {
    const response = await api.delete(`/preferences/ai/user/${user_id}/models/${provider}/${model}`);
    return response.data;
  },
  setDefaultAIModel: async (user_id, provider, model) => {
    const response = await api.put(`/preferences/ai/user/${user_id}/models/${provider}/${model}/default`);
    return response.data;
  }
};
